module.exports = __webpack_public_path__ + "img/logo-outline.64fb5039.webp";